export interface SiteConfig {
  name: string;
  url: string;
  email: string;
  whatsapp: string;
  whatsappDisplay: string;
  phone: string;
  linkedin: string;
  github: string;
  contactEndpoint: string;
}

export const siteConfig: SiteConfig = {
  name: "ByteOps",
  url: "https://bytesops.com",
  email: "", // Configurable: Leave blank until official email is active
  whatsapp: "https://wa.me/923261057877?text=Hi%20ByteOps%2C%20I%27d%20like%20to%20discuss%20a%20cloud%20or%20DevOps%20project.",
  whatsappDisplay: "+92 326 1057877",
  phone: "",
  linkedin: "https://www.linkedin.com/in/shahzaib-mehmood/",
  github: "https://github.com/Shahzaib175",
  contactEndpoint: process.env.NEXT_PUBLIC_CONTACT_ENDPOINT || "/api/contact",
};
